import React from "react";
// Spinner
import { Spinner } from "react-bootstrap";
// Styled Components
import styled from "styled-components";
// React Bootstrap
import { Image } from "react-bootstrap";

/*
CustomSpinner: Custom spinner ajustado con estilos para que se centre en un componente y ponga el fondo en blanco
    Parametros:
        * size      => Tamaño del spinner (esta ajustado solo para los de sm)
        * animation => Animacion que tendrá el spinner de react bootstrap
        * variant   => Variante de stilos de colores propios de react bootstrap
        * loading   => Controla si se muestra o no el spinner
*/
// El div que contenga al spinner debe tener positioin:relative

const CustomContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #d4d4d487;
  position: absolute;
  z-index: ${({ zIndex }) => (zIndex ? zIndex : 5000)}; ;
`;

const CustomSpinnerReact = styled(Spinner)`
  position: absolute;
  top: 50%;
  right: 50%;
  margin-top: -16px;
  margin-right: -16px;
  display: ${(loading) => (loading ? "d-none" : null)};
`;

const MyImageResponsive = styled(Image)`
  width: auto;
  height: auto;
  display: block;
  margin: auto;
  max-width: 50%;
  margin-top: 150px;
`;

const CustomSpinner = ({ size = "md", showPhoto = false, animation = "border", loading, variant, ...props }) => {
  return loading ? (
    <CustomContainer>
      <CustomSpinnerReact animation={animation} size={size} role="status">
        <span className="sr-only">{"Cargando"} ...</span>
      </CustomSpinnerReact>
    </CustomContainer>
  ) : null;
};

export default CustomSpinner;
